import React, { Dispatch } from 'react'
import { List } from '../../../../../components/common/List'
import { ReportInspectorAction } from '../store'
import { useSearchParams } from '../../../../../hooks/util'
import { Title } from '@mantine/core'

type Props = {
    reports: any[]
    dispatch: Dispatch<ReportInspectorAction>
    lastModified: string | Date
    page: number
}

export const FormulaReports = ({ reports, dispatch, lastModified, page }: Props) => {
    const { setSearchParams } = useSearchParams()
    const columns = [
        { label: 'Report PK', field: 'report_pk' },
        { label: 'Report Name', field: 'report_name' },
        { label: 'Last Modified', field: 'last_modified_time', color: (value: string | Date) => lastModified > value ? 'red' : 'dark' }
    ]

    const handleSelect = (reportPk: number) => {
        setSearchParams({ reportPk: reportPk.toString() })
        dispatch({ type: 'selectFormulaReport', payload: reportPk })
    }

    const handlePageChange = (page: number) => dispatch({ type: 'setFormulaReportsPage', payload: page })

    if (!reports?.length) return <Title order={5} mt={30} ta='center'>This formula is not being used in any reports.</Title>

    return (
        <List
            data={reports}
            dataCount={reports[0].total_count}
            columns={columns}
            uniqueKey='report_pk'
            handleSelect={row => handleSelect(row.report_pk)}
            page={page}
            handlePageChange={handlePageChange}
        />
    )
}